import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
Sentry.init({
  dsn: 'https://a9d3514ca5e1d1ec45254414bdb7656d@o4508880704307200.ingest.us.sentry.io/4508984663670784',
  release: process.env.REACT_APP_RELEASE_SHA,
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click' && hint?.event?.target) {
      const target = hint.event.target as HTMLElement;
      const identifier =
        target.getAttribute('data-qaid') ||
        target.getAttribute('aria-label') ||
        target.innerText?.slice(0, 50) ||
        target.id ||
        null;
      if (identifier) {
        breadcrumb.message = `${identifier} (${breadcrumb.message})`;
      }
    }
    return breadcrumb;
  },
  beforeSend: (event) => {
    if (window.location.hostname === 'localhost') {
      return null;
    }
    return event;
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('trunk-root') as HTMLElement,
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
